import Auth from './Pages/Auth/Auth';
import { BrowserRouter } from 'react-router-dom'
import './scss/index.scss';
import { startActivityWatcher } from "./Common/Client/ActivityWatcher";
import useGTM from './Components/GTM'
import { useEffect } from 'react';
import { startTokenMonitor } from './Common/Client/TokenMonitor';
import UsePreviousRoute from './Components/RetrieveCode/PreviousURL';
function App() {
  // if (process.env.REACT_APP_NODE_ENV === "production") {
  //   console.log = () => { };
  // }
  const gtmId = process.env.REACT_APP_GTM_ID || "GTM-XXXXXXX";

  useGTM(gtmId);
  useEffect(() => {
    let check = setInterval(() => {
      const login = sessionStorage.getItem("login");
      const expiry = sessionStorage.getItem("expirytime");
      const minutes = sessionStorage.getItem("expiryTimeInMintue");

      if (login === "true" && expiry && minutes) {
        clearInterval(check);

        startActivityWatcher();       // run after sessionStorage available
        const monitor = startTokenMonitor();

        return () => clearInterval(monitor);
      }
    }, 300);

    return () => clearInterval(check);
  }, []);

  return (
    <BrowserRouter >
      <UsePreviousRoute />
      <Auth />
    </BrowserRouter>
  );
}

export default App;
